import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import config from "../../../config.json";

@Component({
  selector: 'app-video-modal',
  templateUrl: './video-modal.component.html',
  styleUrls: ['./video-modal.component.css']
})
export class VideoModalComponent implements OnInit {
  @Input() public idVideo: any;
  serverAddress: string = '';

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    this.serverAddress = config.serverAddress + ':' + config.serverPort + '/';
  }

}
